import type { FC } from 'react';
import { useLocation } from 'react-router-dom';
import { GroupWrap } from 'src/components/group-wrap';
import type { ActiveSection } from 'src/components/layout/header/types';
import { ExternalLink, Link } from 'src/components/navigation/link';
import { useBreakpoints } from 'src/hooks/use-breakpoints';
import { useOptionalAuthenticatedMonolithUser } from 'src/hooks/use-monolith-user';

export const isStorageActive = (pathname: string, hash: string) =>
  pathname.startsWith('/storage') ||
  (pathname.startsWith('/platform') && hash.startsWith('#/storage'));

export const SecondaryNavStorage: FC<{ activeSection: ActiveSection }> = ({
  activeSection,
}) => {
  const { hash, pathname } = useLocation();
  const monolithUser = useOptionalAuthenticatedMonolithUser();
  const { minTablet } = useBreakpoints();

  if (!activeSection.storage) return null;

  return (
    <GroupWrap
      gap={[1, 2]}
      data-testid="secondary-nav"
      alignItems={!minTablet ? 'stretch' : 'center'}
      flexDirection={!minTablet ? 'column' : 'row'}
    >
      {monolithUser?.isShipper && (
        <>
          <Link
            mode="secondary"
            to="/storage/offers"
            isActive={
              pathname.startsWith('/storage/offers') ||
              (pathname.startsWith('/platform') &&
                hash.startsWith('#/storage/offers'))
            }
          >
            Auctions
          </Link>

          <ExternalLink
            mode="secondary"
            href={`${PRISMA_CONFIG.angularUrl}/#/storage/booking`}
          >
            FCFS Booking
          </ExternalLink>
        </>
      )}

      {monolithUser?.isSso && (
        <>
          <Link
            mode="secondary"
            to="/storage/offers"
            isActive={
              pathname.startsWith('/storage/offers') ||
              (pathname.startsWith('/platform') &&
                hash.startsWith('#/storage/offers') &&
                !hash.startsWith('#/storage/offers/create'))
            }
          >
            Manage Offer
          </Link>

          <ExternalLink
            mode="secondary"
            href={`${PRISMA_CONFIG.angularUrl}/#/storage/offers/create`}
            isActive={
              pathname.startsWith('/platform') &&
              hash.startsWith('#/storage/offers/create')
            }
          >
            Create Offer
          </ExternalLink>

          <Link
            mode="secondary"
            to="/storage/locations"
            isActive={
              pathname.startsWith('/storage/locations') ||
              (pathname.startsWith('/platform') &&
                hash.startsWith('#/storage/locations'))
            }
          >
            Storage Locations
          </Link>
        </>
      )}
    </GroupWrap>
  );
};
